// MODE
import * as localhost from './localhost.js'
import * as production from './production.js'

const MODE = import.meta.env.MODE
const provider = MODE === 'development' ? localhost : production

const fetchPageInfo = provider.fetchPageInfo
const fetchLogin = provider.fetchLogin
const fetchLogout = provider.fetchLogout
const fetchForgotPassword = provider.fetchForgotPassword
const fetchCheckTeamsByHost = provider.fetchCheckTeamsByHost
const fetchLoginTanetPair = provider.fetchLoginTanetPair
const fetchForceChange = provider.fetchForceChange
const fetchAssessmentUnits = provider.fetchAssessmentUnits
const fetchCreateAssessment = provider.fetchCreateAssessment
const fetchUpdateRoomAnswer = provider.fetchUpdateRoomAnswer
const fetchFinishRoom = provider.fetchFinishRoom
const fetchExamReview = provider.fetchExamReview
const fetchExamDelete = provider.fetchExamDelete
const fetchWebRoomFinish = provider.fetchWebRoomFinish
const fetchCinemaRoomVideoProgress = provider.fetchCinemaRoomVideoProgress
const fetchCinemaRoomPlayed = provider.fetchCinemaRoomPlayed

export const commonAPI = {
    fetchPageInfo,
    fetchLogout
}

export const loginAPI = {
    fetchPageInfo,
    fetchLogin,
    fetchForgotPassword,
}

export const tanetPairAPI = {
    fetchPageInfo,
    fetchCheckTeamsByHost,
    fetchLoginTanetPair
}

export const forceChangeAPI = {
    fetchPageInfo,
    fetchForceChange
}

export const assessmentUnitsAPI = {
    fetchPageInfo,
    fetchAssessmentUnits,
    fetchCreateAssessment
}

export const examAPI = {
    fetchPageInfo,
    fetchUpdateRoomAnswer,
    fetchFinishRoom,
    fetchExamReview,
    fetchExamDelete
}

export const webRoomAPI = {
    fetchPageInfo,
    fetchWebRoomFinish
}

export const cinemaRoomAPI = {
    fetchPageInfo,
    fetchCinemaRoomVideoProgress,
    fetchCinemaRoomPlayed
}








